import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { Col, Row } from 'react-bootstrap'
import './CrossAccountBanner.scss'
import { useGetHomeAccountQuery } from '../../store/crossAccount/crossAccount'
import { useGetAccountQuery } from '../../store/accountUserSettings/accountUserSettings'

export const CrossAccountBanner: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: account } = useGetAccountQuery({ accountId })
  const { data: homeAccount } = useGetHomeAccountQuery()
  const [isCrossAccount, setIsCrossAccount] = useState(false)

  useEffect(() => {
    if (homeAccount) {
      setIsCrossAccount(homeAccount.id != accountId)
    }
  }, [accountId, homeAccount])

  if (!isCrossAccount) {
    return null
  }

  return (
    <Row className='cross-account-banner pt-2 pb-2 header-banner'>
      <Col className='d-flex'>
        <div className='d-flex gap-2 align-items-center justify-content-center flex-grow-1 px-3'>
          <i className='bi bi-info-circle' />
          {account ? (
            <div className='text-center'>
              You're working in {account.data.name} (not your default account). Use one browser tab only to avoid account issues.
            </div>
          ) : null}
        </div>
      </Col>
    </Row>
  )
}
